import { createUseStyles } from 'react-jss';
import { AlertManagerProps } from '.';
import { Classes } from 'jss';

const leftPosition = {
  alignItems: 'flex-start',
  left: '20px',
};

const centerPosition = {
  alignItems: 'center',
  left: 0,
  right: 0,
};

const rightPosition = {
  alignItems: 'flex-end',
  right: '20px',
};

export const useAlertManagerClasses: (
  data?: AlertManagerProps & {
    theme?: Jss.Theme;
  },
) => Classes<'position' | 'root' | 'alertAnimation'> = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: '20px',
    zIndex: 1,

    '& > *': {
      marginBottom: '20px',
    },
  },
  position: ({ position }: AlertManagerProps): typeof leftPosition | typeof centerPosition | typeof rightPosition => {
    switch (position) {
      case 'left':
        return leftPosition;
      case 'center':
        return centerPosition;
      case 'right':
        return rightPosition;
      default:
        return 'Unreachable' as never;
    }
  },
  alertAnimation: {
    animation: ({ position }: AlertManagerProps) => {
      switch (position) {
        case 'left':
          return 'slideInFromLeft 500ms ease-out';
        case 'center':
          return 'slideInFromTop 500ms ease-out';
        case 'right':
          return 'slideInFromRight 500ms ease-out';
        default:
          return 'Unreachable' as never;
      }
    },
  },
});
